import { SchemaFormFields } from '@mews-commander/form';
import { FieldsContainer } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack, Title } from '@optimus-web/core';
import { updateFormDefinition } from '../../formDefinitions';
import { updateSchema as commonUpdateSchema } from '../../schemas';

type IntegrationUpdateFormLayoutProps = {
    hideEnableBanner?: boolean;
} & React.PropsWithChildren<{}>;

export const IntegrationUpdateFormLayout = ({ children, hideEnableBanner }: IntegrationUpdateFormLayoutProps) => (
    <FieldsContainer>
        <Stack spacing="300" vertical>
            <Title level={2}>{lt('Settings')}</Title>
            {children}
            <Title level={2}>{lt('Enable')}</Title>
            {!hideEnableBanner ? (
                <Banner
                    variant="info"
                    secondaryText={lt(
                        TextKey.EnterpriseIntegrationSettingsEnableIntegrationAfterYouReceiveConfirmation
                    )}
                />
            ) : null}
            <SchemaFormFields schema={commonUpdateSchema} formDefinition={updateFormDefinition} />
        </Stack>
    </FieldsContainer>
);
